import { zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";

export const timezones = {
  "America/Punta_Arenas": "Chile",
  "Asia/Atyrau": "Kazakhstan",
  "Asia/Calcutta": "India",
  "Asia/Famagusta": "Cyprus",
  "Asia/Qostanay": "Kazakhstan",
  "Asia/Yangon": "Myanmar",
  "Canada/Atlantic": "Canada",
  "Canada/Central": "Canada",
  "Canada/Eastern": "Canada",
  "Canada/Mountain": "Canada",
  "Canada/Newfoundland": "Canada",
  "Canada/Pacific": "Canada",
  "Etc/UTC": "UTC",
  "Europe/Saratov": "Russia",
  GMT: "Greenwich Mean Time",
  "Atlantic/Canary": "Spain",
  "Europe/Lisbon": "Portugal",
  "Antarctica/Mawson": "Antarctica",
  "America/Nipigon": "Canada",
  "America/Miquelon": "St Pierre & Miquelon",
  "Indian/Reunion": "Réunion",
  "America/Fort_Nelson": "Canada",
  "Europe/Skopje": "Macedonia",
  "Asia/Dhaka": "Bangladesh",
  "America/St_Lucia": "St Lucia",
  "America/Phoenix": "United States",
  "Europe/Kaliningrad": "Russia",
  "Asia/Hong_Kong": "Hong Kong",
  "Arctic/Longyearbyen": "Svalbard & Jan Mayen",
  "Europe/Guernsey": "Guernsey",
  "Europe/Paris": "France",
  "Europe/Stockholm": "Sweden",
  "Pacific/Fiji": "Fiji",
  "Pacific/Apia": "Samoa (western)",
  "Pacific/Pago_Pago": "Samoa (American)",
  "Asia/Rangoon": "Myanmar (Burma)",
  "America/Mexico_City": "Mexico",
  "America/Puerto_Rico": "Puerto Rico",
  "Indian/Mauritius": "Mauritius",
  "Europe/Berlin": "Germany",
  "Europe/Zurich": "Switzerland",
  "Africa/Casablanca": "Morocco",
  "Antarctica/Davis": "Antarctica",
  "Asia/Krasnoyarsk": "Russia",
  "Atlantic/Bermuda": "Bermuda",
  "America/Araguaina": "Brazil",
  "Asia/Tehran": "Iran",
  "Asia/Baku": "Azerbaijan",
  "America/St_Barthelemy": "St Barthelemy",
  "America/Santarem": "Brazil",
  "America/Danmarkshavn": "Greenland",
  "America/Scoresbysund": "Greenland",
  "America/Eirunepe": "Brazil",
  "America/Caracas": "Venezuela",
  "Asia/Baghdad": "Iraq",
  "Africa/Monrovia": "Liberia",
  "America/St_Vincent": "St Vincent",
  "America/Vancouver": "Canada",
  "Asia/Ho_Chi_Minh": "Vietnam",
  "Europe/Busingen": "Germany",
  "Asia/Thimphu": "Bhutan",
  "Africa/Accra": "Ghana",
  "America/Belize": "Belize",
  "America/Edmonton": "Canada",
  "Asia/Tashkent": "Uzbekistan",
  "Asia/Tokyo": "Japan",
  "Pacific/Kiritimati": "Kiribati",
  "Australia/Sydney": "Australia",
  "Europe/Riga": "Latvia",
  "Asia/Dili": "East Timor",
  "Africa/Mbabane": "Swaziland",
  "Asia/Oral": "Kazakhstan",
  "Asia/Aden": "Yemen",
  "Europe/Isle_of_Man": "Isle of Man",
  "Europe/Istanbul": "Turkey",
  "Africa/Abidjan": "Côte d'Ivoire",
  "Australia/Lindeman": "Australia",
  "Pacific/Galapagos": "Ecuador",
  "America/Bogota": "Colombia",
  "America/Dawson": "Canada",
  "America/Chicago": "United States",
  "Pacific/Kwajalein": "Marshall Islands",
  "Australia/Broken_Hill": "Australia",
  "America/Cuiaba": "Brazil",
  "Indian/Christmas": "Christmas Island",
  "Asia/Jayapura": "Indonesia",
  "Europe/Brussels": "Belgium",
  "America/Argentina/Cordoba": "Argentina",
  "America/Noronha": "Brazil",
  "Europe/Podgorica": "Montenegro",
  "Africa/Algiers": "Algeria",
  "Africa/Harare": "Zimbabwe",
  "Africa/Ndjamena": "Chad",
  "America/Costa_Rica": "Costa Rica",
  "Europe/Ljubljana": "Slovenia",
  "Indian/Mayotte": "Mayotte",
  "Asia/Phnom_Penh": "Cambodia",
  "America/Managua": "Nicaragua",
  "Asia/Brunei": "Brunei",
  "America/Tijuana": "Mexico",
  "Pacific/Fakaofo": "Tokelau",
  "America/Adak": "United States",
  "America/Antigua": "Antigua & Barbuda",
  "America/Indiana/Indianapolis": "United States",
  "America/Argentina/La_Rioja": "Argentina",
  "Pacific/Tahiti": "French Polynesia",
  "America/Pangnirtung": "Canada",
  "Europe/Zagreb": "Croatia",
  "America/Asuncion": "Paraguay",
  "Europe/Vienna": "Austria",
  "Australia/Hobart": "Australia",
  "America/Juneau": "United States",
  "America/Inuvik": "Canada",
  "America/Ojinaga": "Mexico",
  "Europe/Astrakhan": "Russia",
  "Asia/Seoul": "Korea (South)",
  "Indian/Comoro": "Comoros",
  "Antarctica/Rothera": "Antarctica",
  "Europe/Tallinn": "Estonia",
  "Indian/Mahe": "Seychelles",
  "America/Argentina/Jujuy": "Argentina",
  "America/Creston": "Canada",
  "America/Martinique": "Martinique",
  "Asia/Singapore": "Singapore",
  "Africa/Nairobi": "Kenya",
  "Asia/Pontianak": "Indonesia",
  "America/Maceio": "Brazil",
  "Africa/Cairo": "Egypt",
  "Europe/Moscow": "Russia",
  "Antarctica/Palmer": "Antarctica",
  "Asia/Ulaanbaatar": "Mongolia",
  "America/Rainy_River": "Canada",
  "Indian/Maldives": "Maldives",
  "Asia/Colombo": "Sri Lanka",
  "Australia/Adelaide": "Australia",
  "America/Cambridge_Bay": "Canada",
  "Africa/Luanda": "Angola",
  "Pacific/Chatham": "New Zealand",
  "America/Indiana/Winamac": "United States",
  "Asia/Tbilisi": "Georgia",
  "Europe/Gibraltar": "Gibraltar",
  "Asia/Karachi": "Pakistan",
  "Australia/Lord_Howe": "Australia",
  "America/Bahia_Banderas": "Mexico",
  "America/Boa_Vista": "Brazil",
  "America/Lima": "Peru",
  "Pacific/Wallis": "Wallis & Futuna",
  "Atlantic/Stanley": "Falkland Islands",
  "Asia/Srednekolymsk": "Russia",
  "America/Blanc-Sablon": "Canada",
  "Antarctica/Syowa": "Antarctica",
  "America/Jamaica": "Jamaica",
  "Europe/Kiev": "Ukraine",
  "Europe/Budapest": "Hungary",
  "Pacific/Midway": "US minor outlying islands",
  "America/Goose_Bay": "Canada",
  "Asia/Amman": "Jordan",
  "Asia/Sakhalin": "Russia",
  "Africa/Windhoek": "Namibia",
  "Asia/Makassar": "Indonesia",
  "America/Sitka": "United States",
  "America/Guyana": "Guyana",
  "Pacific/Pohnpei": "Micronesia",
  "America/Sao_Paulo": "Brazil",
  "America/Lower_Princes": "St Maarten (Dutch)",
  "Australia/Perth": "Australia",
  "Africa/Djibouti": "Djibouti",
  "Asia/Jakarta": "Indonesia",
  "Asia/Pyongyang": "Korea (North)",
  "Africa/Johannesburg": "South Africa",
  "Antarctica/Troll": "Antarctica",
  "Asia/Irkutsk": "Russia",
  "US/Pacific": "United States",
  "Africa/Niamey": "Niger",
  "America/Belem": "Brazil",
  "Asia/Bishkek": "Kyrgyzstan",
  "Africa/Nouakchott": "Mauritania",
  "Europe/Vilnius": "Lithuania",
  "America/Cayenne": "French Guiana",
  "Africa/Mogadishu": "Somalia",
  "America/Kentucky/Monticello": "United States",
  "America/Rio_Branco": "Brazil",
  "America/Cancun": "Mexico",
  "America/Havana": "Cuba",
  "Pacific/Guam": "Guam",
  "Antarctica/Macquarie": "Australia",
  "US/Arizona": "United States",
  "Atlantic/Azores": "Portugal",
  "Australia/Eucla": "Australia",
  "Asia/Shanghai": "China",
  "America/Rankin_Inlet": "Canada",
  "America/Iqaluit": "Canada",
  "Africa/Maputo": "Mozambique",
  "Asia/Bahrain": "Bahrain",
  "Asia/Ashgabat": "Turkmenistan",
  "Asia/Riyadh": "Saudi Arabia",
  "Europe/London": "Britain (UK)",
  "Europe/Warsaw": "Poland",
  "America/Anguilla": "Anguilla",
  "Asia/Damascus": "Syria",
  "America/North_Dakota/Center": "United States",
  "America/Indiana/Vevay": "United States",
  "Atlantic/St_Helena": "St Helena",
  "America/Barbados": "Barbados",
  "Europe/Vatican": "Vatican City",
  "America/Indiana/Vincennes": "United States",
  "Asia/Almaty": "Kazakhstan",
  "America/Santo_Domingo": "Dominican Republic",
  "Africa/Brazzaville": "Congo (Rep.)",
  "America/Nome": "United States",
  "Asia/Taipei": "Taiwan",
  "America/Yakutat": "United States",
  "America/Argentina/Mendoza": "Argentina",
  "America/Tortola": "Virgin Islands (UK)",
  "Europe/Vaduz": "Liechtenstein",
  "Europe/Minsk": "Belarus",
  "Asia/Kolkata": "India",
  "Africa/Maseru": "Lesotho",
  "America/Atikokan": "Canada",
  "Asia/Kuching": "Malaysia",
  "Africa/Libreville": "Gabon",
  "Africa/Freetown": "Sierra Leone",
  "Africa/Bissau": "Guinea-Bissau",
  "Europe/Samara": "Russia",
  "Europe/Amsterdam": "Netherlands",
  "Europe/Tirane": "Albania",
  "Pacific/Saipan": "Northern Mariana Islands",
  "Asia/Magadan": "Russia",
  "Europe/Zaporozhye": "Ukraine",
  "America/El_Salvador": "El Salvador",
  "Europe/Madrid": "Spain",
  "Africa/Juba": "South Sudan",
  "America/Santiago": "Chile",
  "America/Argentina/Buenos_Aires": "Argentina",
  "America/Argentina/San_Luis": "Argentina",
  "America/Aruba": "Aruba",
  "America/Regina": "Canada",
  "Pacific/Chuuk": "Micronesia",
  "Asia/Khandyga": "Russia",
  "Pacific/Funafuti": "Tuvalu",
  "America/Merida": "Mexico",
  "America/Guatemala": "Guatemala",
  "Africa/Lome": "Togo",
  "Africa/Sao_Tome": "Sao Tome & Principe",
  "Asia/Tomsk": "Russia",
  "Pacific/Kosrae": "Micronesia",
  "Africa/Bujumbura": "Burundi",
  "Europe/Chisinau": "Moldova",
  "America/Monterrey": "Mexico",
  "Asia/Yekaterinburg": "Russia",
  "US/Hawaii": "United States",
  "Antarctica/Casey": "Antarctica",
  "Pacific/Enderbury": "Kiribati",
  "America/Thule": "Greenland",
  "America/St_Johns": "Canada",
  "America/Moncton": "Canada",
  "Europe/Helsinki": "Finland",
  "Atlantic/Cape_Verde": "Cape Verde",
  "America/Tegucigalpa": "Honduras",
  "Indian/Cocos": "Cocos (Keeling) Islands",
  "America/Boise": "United States",
  "America/Guadeloupe": "Guadeloupe",
  "America/Nassau": "Bahamas",
  "Europe/Prague": "Czech Republic",
  "America/Halifax": "Canada",
  "Asia/Hovd": "Mongolia",
  "America/Manaus": "Brazil",
  "America/Godthab": "Greenland",
  "America/North_Dakota/Beulah": "United States",
  "America/Chihuahua": "Mexico",
  "Asia/Beirut": "Lebanon",
  "America/Argentina/Rio_Gallegos": "Argentina",
  "Pacific/Gambier": "French Polynesia",
  "Europe/Volgograd": "Russia",
  "Africa/Bamako": "Mali",
  "Asia/Novokuznetsk": "Russia",
  "Europe/Uzhgorod": "Ukraine",
  "Africa/Banjul": "Gambia",
  "Asia/Aqtau": "Kazakhstan",
  "Africa/Malabo": "Equatorial Guinea",
  "Atlantic/Madeira": "Portugal",
  "Pacific/Noumea": "New Caledonia",
  "Africa/Kinshasa": "Congo (Dem. Rep.)",
  "Europe/Malta": "Malta",
  "America/Argentina/Ushuaia": "Argentina",
  "Asia/Bangkok": "Thailand",
  "Pacific/Niue": "Niue",
  "Australia/Brisbane": "Australia",
  "America/Recife": "Brazil",
  "Asia/Yerevan": "Armenia",
  "America/La_Paz": "Bolivia",
  "Asia/Urumqi": "China",
  "Africa/Lusaka": "Zambia",
  "Pacific/Guadalcanal": "Solomon Islands",
  "America/Yellowknife": "Canada",
  "Asia/Vientiane": "Laos",
  "Asia/Kuwait": "Kuwait",
  "Africa/Conakry": "Guinea",
  "America/Argentina/Tucuman": "Argentina",
  "Asia/Chita": "Russia",
  "Asia/Hebron": "Palestine",
  "Europe/Oslo": "Norway",
  "Australia/Currie": "Australia",
  "America/St_Kitts": "St Kitts & Nevis",
  "America/Panama": "Panama",
  "America/Hermosillo": "Mexico",
  "Pacific/Palau": "Palau",
  "America/Guayaquil": "Ecuador",
  "Asia/Kuala_Lumpur": "Malaysia",
  "America/Menominee": "United States",
  "Asia/Kamchatka": "Russia",
  "Asia/Vladivostok": "Russia",
  "America/Matamoros": "Mexico",
  "Asia/Qatar": "Qatar",
  "Asia/Dubai": "United Arab Emirates",
  "Asia/Yakutsk": "Russia",
  "Asia/Omsk": "Russia",
  "Africa/Bangui": "Central African Rep.",
  "America/Paramaribo": "Suriname",
  "Africa/Lubumbashi": "Congo (Dem. Rep.)",
  "Pacific/Marquesas": "French Polynesia",
  "US/Central": "United States",
  "Europe/Bratislava": "Slovakia",
  "Asia/Anadyr": "Russia",
  "America/New_York": "United States",
  "Pacific/Norfolk": "Norfolk Island",
  "Pacific/Rarotonga": "Cook Islands",
  "America/Dominica": "Dominica",
  "Africa/Porto-Novo": "Benin",
  "Asia/Samarkand": "Uzbekistan",
  "America/Kentucky/Louisville": "United States",
  "America/Toronto": "Canada",
  "America/Bahia": "Brazil",
  "Africa/Kampala": "Uganda",
  "Africa/Ouagadougou": "Burkina Faso",
  "Asia/Muscat": "Oman",
  "America/Port_of_Spain": "Trinidad & Tobago",
  "Pacific/Wake": "US minor outlying islands",
  "America/Indiana/Tell_City": "United States",
  "Australia/Darwin": "Australia",
  "America/Whitehorse": "Canada",
  "America/Swift_Current": "Canada",
  "Europe/Copenhagen": "Denmark",
  "America/Argentina/Salta": "Argentina",
  "America/Montserrat": "Montserrat",
  "Europe/Simferopol": "Russia",
  "Africa/Blantyre": "Malawi",
  "America/Detroit": "United States",
  "America/Grenada": "Grenada",
  "Atlantic/Faroe": "Faroe Islands",
  "America/Indiana/Petersburg": "United States",
  "Asia/Kathmandu": "Nepal",
  "Asia/Dushanbe": "Tajikistan",
  "Europe/Athens": "Greece",
  "America/Port-au-Prince": "Haiti",
  "America/Cayman": "Cayman Islands",
  "Africa/Dar_es_Salaam": "Tanzania",
  "America/Curacao": "Curacao",
  "Indian/Kerguelen": "French Southern & Antarctic Lands",
  "Africa/Khartoum": "Sudan",
  "Asia/Manila": "Philippines",
  "Europe/Sarajevo": "Bosnia & Herzegovina",
  "Africa/Douala": "Cameroon",
  "Europe/Rome": "Italy",
  "America/Argentina/San_Juan": "Argentina",
  "America/North_Dakota/New_Salem": "United States",
  "America/Kralendijk": "Caribbean NL",
  "Pacific/Port_Moresby": "Papua New Guinea",
  "Europe/Jersey": "Jersey",
  "Europe/Andorra": "Andorra",
  "Europe/Luxembourg": "Luxembourg",
  "Pacific/Honolulu": "United States",
  "America/St_Thomas": "Virgin Islands (US)",
  "Pacific/Majuro": "Marshall Islands",
  "America/Mazatlan": "Mexico",
  "Asia/Macau": "Macau",
  "Europe/Belgrade": "Serbia",
  "Asia/Choibalsan": "Mongolia",
  "Europe/Mariehamn": "Åland Islands",
  "Antarctica/McMurdo": "Antarctica",
  "America/Thunder_Bay": "Canada",
  "America/Los_Angeles": "United States",
  "Asia/Kabul": "Afghanistan",
  "Indian/Antananarivo": "Madagascar",
  "Atlantic/Reykjavik": "Iceland",
  "Asia/Nicosia": "Cyprus",
  "Asia/Barnaul": "Russia",
  "Pacific/Tongatapu": "Tonga",
  "America/Marigot": "St Martin (French)",
  "Pacific/Pitcairn": "Pitcairn",
  "Pacific/Easter": "Chile",
  "Atlantic/South_Georgia": "South Georgia & the South Sandwich Islands",
  "Africa/El_Aaiun": "Western Sahara",
  "Europe/Kirov": "Russia",
  "America/Campo_Grande": "Brazil",
  "America/Dawson_Creek": "Canada",
  "Antarctica/Vostok": "Antarctica",
  "Europe/Bucharest": "Romania",
  "America/Porto_Velho": "Brazil",
  "Europe/Monaco": "Monaco",
  "America/Indiana/Marengo": "United States",
  "Africa/Ceuta": "Spain",
  "America/Winnipeg": "Canada",
  "Asia/Aqtobe": "Kazakhstan",
  "Africa/Dakar": "Senegal",
  "America/Fortaleza": "Brazil",
  "Pacific/Tarawa": "Kiribati",
  "Africa/Asmara": "Eritrea",
  "Africa/Addis_Ababa": "Ethiopia",
  "Pacific/Efate": "Vanuatu",
  "Pacific/Johnston": "US minor outlying islands",
  "Asia/Qyzylorda": "Kazakhstan",
  "Europe/San_Marino": "San Marino",
  "Asia/Jerusalem": "Israel",
  "Pacific/Auckland": "New Zealand",
  "America/Metlakatla": "United States",
  "America/Denver": "United States",
  "Indian/Chagos": "British Indian Ocean Territory",
  "America/Glace_Bay": "Canada",
  "Pacific/Bougainville": "Papua New Guinea",
  "US/Alaska": "United States",
  "Africa/Tunis": "Tunisia",
  "Europe/Ulyanovsk": "Russia",
  "America/Montevideo": "Uruguay",
  "Asia/Ust-Nera": "Russia",
  "America/Resolute": "Canada",
  "Australia/Melbourne": "Australia",
  "Asia/Gaza": "Palestine",
  "Europe/Dublin": "Ireland",
  "US/Mountain": "United States",
  "Antarctica/DumontDUrville": "Antarctica",
  "America/Argentina/Catamarca": "Argentina",
  "America/Indiana/Knox": "United States",
  "Asia/Novosibirsk": "Russia",
  "Africa/Kigali": "Rwanda",
  "US/Eastern": "United States",
  "America/Grand_Turk": "Turks & Caicos Is",
  "America/Anchorage": "United States",
  "Africa/Lagos": "Nigeria",
  "Europe/Sofia": "Bulgaria",
  "Africa/Tripoli": "Libya",
  "Africa/Gaborone": "Botswana",
  "Pacific/Nauru": "Nauru",
  UTC: "UTC",
};

// whenever user is picking date in local timezone oriented component, that should be pass to BE in UTC
export const asUTC = (date) => {
  return zonedTimeToUtc(date);
};

// whenever BE is responding with date, that should be displayed in local timezone oriented component
export const asLocalTime = (date) => {
  return utcToZonedTime(date);
};
